module.exports = __webpack_public_path__ + "img/3.461f02af.jpg";